// // ProfileLogout.jsx

import { Link, useNavigate } from 'react-router-dom';
import { handleLogout } from './AuthUtils';
import './ProfileLogout.css'; // Add this line for custom styles

const ProfileLogout = () => {
  const navigate = useNavigate();
  const storedData = localStorage.getItem('userObjectArray');
  let username = 'Guest';

  if (storedData) {
    try {
      const parsedData = JSON.parse(storedData);
      if (Array.isArray(parsedData) && parsedData[0]?.name) {
        username = parsedData[0].name;
      }
    } catch (error) {
      console.error('Error parsing userObjectArray:', error);
    }
  }

  const onButtonClick = () => {
    handleLogout();
    navigate('/login');
  };

  return (
    <div className="profile-card">
      <div className="profile-header">👤 Profile</div>
      <div className="profile-body">
        <p className="profile-welcome">Welcome, <strong>{username}</strong></p>
        <Link to="#" className="logout-button" onClick={onButtonClick}>
          🔓 Logout
        </Link>
      </div>
    </div>
  );
};

export default ProfileLogout;
